// extracted by mini-css-extract-plugin
export var deliveryRow = "_sl-a";
export var fixedHeight = "_sl-4";
export var freightLogo = "_sl-9";
export var fullWidth = "_sl-3";
export var priceColumn = "_sl-5";
export var radioSelected = "_sl-7";
export var radioUnselected = "_sl-6";
export var selectedOption = "_sl-2";
export var selectedOptionContainer = "_sl-1";
export var selection = "_sl-0";
export var tallSkeletonText = "_sl-8";